const config = {
  backendUrl: process.env.REACT_APP_BACKEND_URL || "http://localhost:3000/api/",
  baseUrl: process.env.REACT_APP_BACKEND_URL || "http://localhost:3000/api/",
  timeout: 10000,
};

export default config;
